import { mobiClient } from '@/services/axiosConfig'
import { getMetaAttribution } from '@/utils/metaPixel'
import { CreateInvoiceReq, CreateInvoiceRes, Invoice } from './types'

export default {
  create: async (req: CreateInvoiceReq): Promise<CreateInvoiceRes | undefined> => {
    try {
      const attribution = getMetaAttribution()
      const payload = attribution.fbc ? { ...req, ...attribution } : req
      const res = await mobiClient.post('/invoice', payload)
      return res.data
    } catch (e: any) {
      console.error(e)
      return e.response.data
    }
  },
  get: async (id: string): Promise<Invoice | undefined> => {
    try {
      const headers = { id }
      const res = await mobiClient.get('/invoice', { headers })
      return res.data
    } catch (e) {
      console.error(e)
    }
  }
}
